export default __webpack_public_path__ + "static/media/flashsale.3cd28ca5.png";